export const helpTextErrorHelper = (val: boolean | string) => (!!val ? val : '')
